import { Viewer } from 'models'
import { SortTabEnums } from 'pages/viewers/ViewersPage/SortTabs'
import { PaginationSearchBase } from 'store/PaginationSearchBase'
import { TriggerSearchFunc } from 'store/PaginationSearchBase/PaginationSearchBase.types'
import { RootStore } from 'store/RootStore'
import { VIEWERS_STORE } from 'store/ViewersStore'
import { isDescending } from 'utilities'
import {
  initialViewersPaginationProps,
  initialViewersSearchProps,
  ViewersTableSearchProps,
  ViewersTableSortProps
} from './ViewersTableStore.types'

export const VIEWERS_TABLE_STORE = 'VIEWERS_TABLE_STORE'

export class ViewersTableStore extends PaginationSearchBase<
  ViewersTableSortProps,
  ViewersTableSearchProps,
  Viewer
> {
  private rootStore: RootStore

  constructor (rootStore: RootStore) {
    super(
      initialViewersPaginationProps,
      initialViewersSearchProps,
      [],
      ['fullName', 'email']
    )

    this.rootStore = rootStore
  }

  public triggerSearch: TriggerSearchFunc = () => {
    const {
      [VIEWERS_STORE]: {
        sortedViewers,
        selectedSortTab
      }
    } = this.rootStore

    const {
      fullName,
      email,
      sex
    } = this.searchProps

    const list = sortedViewers
      .filter(v => {
        const nameFilter = v.fullName.toLowerCase()
          .includes(fullName.trim().toLowerCase())
        const emailFilter = v.emailAddress.toLowerCase()
          .includes(email.trim().toLowerCase())
        const genderFilter = sex
          ? v.sex === sex
          : true

        return nameFilter && emailFilter && genderFilter
      })

    const {
      sortDirection
      // sortProp
    } = this.pagination
    const sortByDynamicCol = {
      [SortTabEnums.TOTAL_WATCH]: (a: Viewer, b: Viewer) => {
        return isDescending(sortDirection)
          ? b.totalWatchTime - a.totalWatchTime
          : a.totalWatchTime - b.totalWatchTime
      },
      [SortTabEnums.INTERACTION_TIME]: (a: Viewer, b: Viewer) => {
        return isDescending(sortDirection)
          ? b.totalInteractionTime - a.totalInteractionTime
          : a.totalInteractionTime - b.totalInteractionTime
      },
      [SortTabEnums.ADD_REVENUE]: (a: Viewer, b: Viewer) => {
        return isDescending(sortDirection)
          ? b.totalAddRevenue - a.totalAddRevenue
          : a.totalAddRevenue - b.totalAddRevenue
      },
      [SortTabEnums.TOTAL_SPENT]: (a: Viewer, b: Viewer) => {
        return isDescending(sortDirection)
          ? b.totalSpent - a.totalSpent
          : a.totalSpent - b.totalSpent
      }
    }[selectedSortTab]

    this.setSearchResults(list.sort(sortByDynamicCol))
  }
}
